import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Del 1",
  "description": "",
  "published": "2006-05-12T00:00:00.000Z",
  "redirect_from": ["/blog/del-1/swizec/417"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=show_comics/comic=1"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/sneeks/01_thumb.jpg",
          "alt": null
        }}></img></a></p>
    <p>{`Malo kasneje od priÄakovanega, vendar prvi del je konÄno tu. Je veliko stvari za povedat ampak ne ravno v tem trenutku.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      